export const filterSchemaConfig = {
  reject_rate_min: {
    prop: 'reject_rate_min',
    component: 'input-number',
    field: {
      controls: false,
      min: 0,
      max: 100,
      clearable: true,
      placeholder: '最小',
    },
  },
  reject_rate_max: {
    prop: 'reject_rate_max',
    component: 'input-number',
    field: {
      controls: false,
      min: 0,
      max: 100,
      clearable: true,
      placeholder: '最大',
    },
  },
  porn_rate_min: {
    prop: 'porn_rate_min',
    component: 'input-number',
    field: {
      controls: false,
      min: 0,
      max: 100,
      clearable: true,
      placeholder: '最小',
    },
  },
  porn_rate_max: {
    prop: 'porn_rate_max',
    component: 'input-number',
    field: {
      controls: false,
      min: 0,
      max: 100,
      clearable: true,
      placeholder: '最大',
    },
  },
  political_rate_min: {
    prop: 'political_rate_min',
    component: 'input-number',
    field: {
      controls: false,
      min: 0,
      max: 100,
      clearable: true,
      placeholder: '最小',
    },
  },
  political_rate_max: {
    prop: 'political_rate_max',
    component: 'input-number',
    field: {
      controls: false,
      min: 0,
      max: 100,
      clearable: true,
      placeholder: '最大',
    },
  },
  video_min: {
    prop: 'video_min',
    component: 'input-number',
    field: {
      controls: false,
      min: 0,
      placeholder: '最小',
    },
  },
  video_max: {
    prop: 'video_max',
    component: 'input-number',
    field: {
      controls: false,
      min: 0,
      placeholder: '最大',
    },
  },
  image_min: {
    prop: 'image_min',
    component: 'input-number',
    field: {
      controls: false,
      min: 0,
      clearable: true,
      placeholder: '最小',
    },
  },
  image_max: {
    prop: 'image_max',
    component: 'input-number',
    field: {
      controls: false,
      min: 0,
      clearable: true,
      placeholder: '最大',
    },
  },
  pl_min: {
    prop: 'pl_min',
    component: 'input-number',
    field: {
      controls: false,
      min: 0,
      clearable: true,
      placeholder: '最小',
    },
  },
  pl_max: {
    prop: 'pl_max',
    component: 'input-number',
    field: {
      controls: false,
      min: 0,
      clearable: true,
      placeholder: '最大',
    },
  },
}
